// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1659":"0be0b87c","60154":"0be0b87c"}[chunkId] + ".chunk.css";
};